import { render, staticRenderFns } from "./OrderSetItem.vue?vue&type=template&id=09c05a78&"
import script from "./OrderSetItem.vue?vue&type=script&lang=js&"
export * from "./OrderSetItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports